module.exports = __webpack_public_path__ + "img/home4.6cd0cbd1.png";